import { ignoreCypress } from '@util/ignore-cypress'
/**
 * abstraction around Segment's identity method
 * Segment spec: https://segment.com/docs/connections/spec/identify/
 *
 * Thrive spec for this call: https://thrive-global.atlassian.net/wiki/spaces/DG/pages/331186177/Web+Sign+Up#Identify
 */

type Traits = {
  user_id: string
  company_id: string
}

const segmentIdentify = (traits: Traits) => {
  const analytics = window.analytics
  analytics.reset()

  if(!traits) {
    analytics.identify()
    return
  }

  analytics.identify(traits.user_id, traits)
}

export const identify = ignoreCypress(segmentIdentify)
